@if (loading) {
  <app-loader></app-loader>
}
<app-loader *ngIf="loading"></app-loader>

  <div class="d-flex align-items-center filter-wrapper">
    <i class="fas fa-filter filter-wrapper-icon hvr-shrink mr-5" (click)="open(ingestionListFilter)"
    ngbTooltip="View report packs" container="body"></i>
    <div class="filter-wrapper-content" *ngIf="!ingForBannerDisplay">No Ingestion Selected</div>
    <div *ngIf="ingForBannerDisplay" class="filter-wrapper-content d-flex align-items-center justify-content-center">
    @if (ingForBannerDisplay) {
      <div class="filter-wrapper-content d-flex align-items-center justify-content-center">
        <div class="col-12 specify-overflow" id="overflowCheck">
          <span class="value mr-3">
            <span class="title">Load ID | </span>{{ingForBannerDisplay.loadid}}
          </span>
          <span class="value mr-3">
            <span class="title">Report Pack ID | </span>{{ingForBannerDisplay.reportPackId}}
          </span>
          <span class="value mr-3">
            <span class="title">File Name | </span>{{ingForBannerDisplay.filename}}
          </span>
          <span class="value mr-3">
            <span class="title">Report Date | </span>
             {{ ingForBannerDisplay.createddate | date : 'dd/MM/yyyy' }}
                  
                  {{ ingForBannerDisplay.createddate | date : 'hh:mm:ss a' }}
          </span>
         
      </div>
    </div>
  }
  @if ((ingForBannerDisplay) && (ingForBannerDisplay.RP_Description != null)) {
    <i class="fas fa-align-center filter-wrapper-icon2 hvr-shrink ml-5"
      ngbTooltip="View description"
    container="body" (click)="openModal(descriptionContent); overflowToolCheck()"></i>
  }
</div>
</div>

<ng-template #ingestionListFilter>
   <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center m-0 w-100">
      Apply Filter<i class="fas fa-times ml-auto cursor-pointer" aria-label="Close" (click)="closeModal();"></i>
    </h5>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <div class="report-filter-scroll">

          <p-table
            #ingdt
            [value]="IngestionList"
            [paginator]="true"
            [rows]="8"
            class="table-irr filter-table"
            [(selection)]="selectedIngRows"
              selectionMode="single"
            [columns]="headerCols"
            [scrollable]="true"
            scrollHeight="400px"
            [tableStyle]="{ 'min-width': '50rem' }"
          >

            <ng-template pTemplate="paginatorleft">
              <button
                class="btn btn-clear-filter hvr-shrink"
                type="button"
                (click)="ingdt.reset();"
              >
                <span>
                  <i class="fas fa-times mr-1"></i>
                  Clear Filters
                </span>
              </button>
            </ng-template>

            <ng-template pTemplate="header" let-columns>
              <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                    {{ col.header }}
                    <p-sortIcon
                      [field]="col.field"
                      ariaLabel="Activate to sort"
                      ariaLabelDesc="Activate to sort in descending order"
                      ariaLabelAsc="Activate to sort in ascending order"
                    >
                    </p-sortIcon>
                  </th>
              </tr>
            </ng-template>
            
            <div class="mt-2 small text-muted">Selected debug: {{ selectedIngRows | json }}</div>

            <ng-template pTemplate="body" let-rowData>
              <tr [pSelectableRow]="rowData">

                <td>
                  <div>
                    {{ rowData.filename }}
                  </div>

                  <div>
                    <span
                      class="badge"
                      [ngClass]="{
                        'badge-completed': rowData.loadstatus === 'Completed',
                        'badge-fail':
                          rowData.loadstatus === 'Failed' ||
                          rowData.loadstatus === 'Abandoned',
                        'badge-in-progress':
                          rowData.loadstatus !== 'Completed' &&
                          rowData.loadstatus !== 'Failed' &&
                          rowData.loadstatus !== 'Abandoned'
                      }"
                    >
                      {{ rowData.loadstatus }}
                    </span>
                  </div>
                </td>

                <td>
                  {{ rowData.reportPackId }}
                </td>

                <td>
                  {{ rowData.reportPack }}
                </td>

                <td>
                  {{ rowData.username }}
                </td>

                <td>
                  {{ rowData.createddate | date : 'dd/MM/yyyy' }}
                  <br />
                  {{ rowData.createddate | date : 'hh:mm:ss a' }}
                </td>

                <td>
                  {{ rowData.rowslandedcount }}
                </td>

                <td>
                  <div
                    class="status-progress d-flex align-items-center position-relative"
                  >
                    <hr />

                    <div
                      class="d-flex align-items-center justify-content-center flex-column mr-3 status-progress-container"
                      [ngClass]="{
                        'completed':
                          rowData.templateValidationStatus === 'Success',
                        'failed':
                          rowData.templateValidationStatus === 'Failed',
                        'in-progress':
                          rowData.templateValidationStatus === 'In Progress'
                      }"
                      container="body"
                      ngbTooltip="Template Validation"
                    >
                      <div
                        class="circle-status d-flex align-items-center justify-content-center"
                      >
                        <i class="fas fa-file-alt fa-lg"></i>
                      </div>
                    </div>

                    <div
                      class="d-flex align-items-center justify-content-center flex-column mr-3 status-progress-container"
                      [ngClass]="{
                        'completed':
                          rowData.dataExtractionStatus === 'Success',
                        'failed':
                          rowData.dataExtractionStatus === 'Failed',
                        'in-progress':
                          rowData.dataExtractionStatus === 'In Progress'
                      }"
                      container="body"
                      ngbTooltip="Data Extraction"
                    >
                      <div
                        class="circle-status d-flex align-items-center justify-content-center"
                      >
                        <i class="fas fa-external-link-alt fa-lg"></i>
                      </div>
                    </div>

                    <div
                      class="d-flex align-items-center justify-content-center flex-column mr-3 status-progress-container"
                      [ngClass]="{
                        'completed':
                          rowData.dataValidationStatus === 'Success',
                        'failed':
                          rowData.dataValidationStatus === 'Failed',
                        'in-progress':
                          rowData.dataValidationStatus === 'In Progress'
                      }"
                      container="body"
                      ngbTooltip="Data Validation"
                    >
                      <div
                        class="circle-status d-flex align-items-center justify-content-center"
                      >
                        <i class="fas fa-tasks fa-lg"></i>
                      </div>
                    </div>

                    <div
                      class="d-flex align-items-center justify-content-center flex-column mr-3 status-progress-container"
                      [ngClass]="{
                        'completed': rowData.dataLoadStatus === 'Success',
                        'failed': rowData.dataLoadStatus === 'Failed',
                        'in-progress':
                          rowData.dataLoadStatus === 'In Progress'
                      }"
                      container="body"
                      ngbTooltip="Data Load"
                    >
                      <div
                        class="circle-status d-flex align-items-center justify-content-center"
                      >
                        <i class="fas fa-cloud-upload-alt fa-lg"></i>
                      </div>
                    </div>

                    <div
                      class="d-flex align-items-center justify-content-center flex-column mr-3 status-progress-container"
                      [ngClass]="{
                        'completed': rowData.dataPrepStatus === 'Success',
                        'failed': rowData.dataPrepStatus === 'Failed',
                        'in-progress':
                          rowData.dataPrepStatus === 'In Progress'
                      }"
                      container="body"
                      ngbTooltip="Data Preparation"
                    >
                      <div
                        class="circle-status d-flex align-items-center justify-content-center"
                      >
                        <i class="fas fa-clipboard-check fa-lg"></i>
                      </div>
                    </div>

                  </div>
                </td>

              </tr>
            </ng-template>

          </p-table>

        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="float-right">
      <button
        class="btn btn-modal-pos small-font hvr-shrink"
        type="button"
        (click)="setSelectedIngestion()"
      >
        <span>Submit</span>
      </button>
    </div>
  </div>
</ng-template>

<div class="row" *ngIf="showEditPanel">
  <div class="col-12">
    <br/>
    <div class="row header">Ingestion Edit</div>
    <app-ingestion-edit></app-ingestion-edit>
  </div>
</div>